jQuery(document).ready(function() {
    var body = jQuery('body');
    var html = jQuery('html');
    var searchInput = jQuery('.search-field input');
    var searchForm = searchInput.closest('form');
    var headerWrapper = jQuery(".header-wrapper");
    var mainContent = jQuery('.main-content');
    var hamburger = jQuery('#hamburger-nav-icon');
    var navWrapper = jQuery('.nav-wrapper');
	var overlay = jQuery('.overlay');
	overlay.off('click').on('click',function() {
		hamburger.removeClass('open-menu');
        navWrapper.removeClass('open-menu')
        html.removeClass('overflow');
        overlay.removeClass('open');
    })
    searchInput.on('keypress', function(e) {
        if (e.which == 13) {
            e.preventDefault();
            searchForm.submit();
        } 
    });
    jQuery('.submit-btn').on('click',function() {
        searchForm.submit();
    })
	jQuery('.search-button, .close-search').on('click',function(e) {
		e.preventDefault();
		jQuery('.search-field').toggleClass('open-search');
        jQuery(searchInput)[0].focus();
        searchInput.val('')
		body.removeClass('overflow');
	});
	jQuery('.arrow-submenu').on('click', function(e) {
		e.stopImmediatePropagation();
		e.preventDefault();
		jQuery(this).closest('li').toggleClass('open-subitem');
	});
    var headerWrapperFunction = function() {
        var windowWidth = jQuery(window).outerWidth();
        var scroll = jQuery(window).scrollTop();
        if (scroll >0) {
            mainContent.addClass("scroll-header");
            headerWrapper.addClass("scroll-header");
        } else {
            mainContent.removeClass("scroll-header");
            headerWrapper.removeClass("scroll-header");
        }
    }
	hamburger.off('click').on('click',function() {
        html.removeClass('overflow');
        overlay.removeClass('open');
		jQuery(this).toggleClass('open-menu');
		navWrapper.toggleClass('open-menu');
		jQuery('.open-subitem').removeClass('open-subitem');
        if(jQuery(this).hasClass('open-menu')) {
            overlay.addClass('open');
            html.addClass('overflow');
        }
	})
    var onResize = function() {
        hamburger.removeClass('open-menu');
        navWrapper.removeClass('open-menu')
        html.removeClass('overflow');
		overlay.removeClass('open');
    }
    var onScroll = function() {
        headerWrapperFunction();
    }
    jQuery(window).resize(onResize);
    jQuery(window).scroll(onScroll);
    onResize();
    onScroll();
})







